// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__bl3Hp"};